import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from 'context/SessionContext';
import { buildLoginPath } from 'utils/pathBuilder';
import { checksession } from 'services/loginService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute component that redirects to login if user is not authenticated
 * @param children - The component to render if user is authenticated
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { session } = useSession();

  // Redirect to login if no session or auth2 token
  if (!session) {
    return <Navigate to={buildLoginPath()} replace />;
  }

  // Render protected content if authenticated
  return <>{children}</>;
};

const Auth2ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { session } = useSession();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuthorization = async () => {

      if (!session) {
        setIsAuthorized(false);
        return;
      }

      if (session._at === 'password') {
          try {
            const response = await checksession();

            if (response) {
              setIsAuthorized(true);
            } else {
              setIsAuthorized(false);
            }
          } catch (error) {
            setIsAuthorized(false);
          }
        } else {
          setIsAuthorized(false);
        }
      };

    checkAuthorization();
  }, [session]);

  if (isAuthorized === null) {
    return <div>Loading...</div>;
  }

  if (!isAuthorized) {
    return <Navigate to={buildLoginPath()} replace />;
  }

  // Render protected content if authenticated
  return <>{children}</>;
};

export { Auth2ProtectedRoute, ProtectedRoute };

